import React, { useState, useRef, useEffect } from "react";
import { VuesaxBulkKey } from "./ui/VuesaxBulkKey";
import { VuesaxBulkSms } from "./ui/VuesaxBulkSms";
import { toast } from "react-hot-toast";
import { useNavigate, Link } from "react-router-dom";
import { useGoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import { FiEye, FiEyeOff } from "react-icons/fi"; // 🗸 React Icons

function LoginPages() {
    const [showPassword, setShowPassword] = useState(false); // hidden initially
  const navigate = useNavigate();

const API_URL = process.env.REACT_APP_BACKAPI_URL;

  const [formData, setFormData] = useState({ email: "", password: "" });

useEffect(() => {
  const remembered = JSON.parse(localStorage.getItem("rememberMe"));
  if (remembered?.email && remembered?.password) {
    setFormData({ email: remembered.email, password: remembered.password });
    setRememberMe(true);
  }
}, []);

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

const handleLogin = async () => {
  const { email, password } = formData;

  if (!email || !password) {
    toast.error("Please enter both email and password.");
    return;
  }

  try {
  const res = await fetch(`${API_URL}/login.php`, {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({ email, password }),
});

    const result = await res.json();

    if (result.status === "success") {
      localStorage.setItem("user", JSON.stringify(result.user));
      window.dispatchEvent(new Event("storage"));

      // Store credentials only if rememberMe is checked
      if (rememberMe) {
        localStorage.setItem("rememberMe", JSON.stringify({ email, password }));
      } else {
        localStorage.removeItem("rememberMe");
      }

      toast.success("Login successful!");
      setTimeout(() => {
        navigate("/profile");
      }, 1500);
    } else {
      toast.error(result.message || "Login failed.");
    }
  } catch (err) {
    toast.error("Something went wrong. Please try again.");
    console.error(err);
  }
};


const handleGoogleLogin = async (credentialResponse) => {
  try {
    let decoded;

    // Decode based on the response format
    if (credentialResponse.credential) {
      decoded = jwtDecode(credentialResponse.credential);
    } else if (credentialResponse.access_token) {
      const userInfoRes = await fetch("https://www.googleapis.com/oauth2/v3/userinfo", {
        headers: {
          Authorization: `Bearer ${credentialResponse.access_token}`,
        },
      });
      decoded = await userInfoRes.json();
    } else {
      toast.error("Google login failed: Invalid response.");
      return;
    }

 // For Google login
const res = await fetch(`${API_URL}/login_google.php`, {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({
    google_id: decoded.sub,
    email: decoded.email,
  }),
});

    const result = await res.json();

    if (result.status === "success") {
      toast.success("Google Login successful!");
      localStorage.setItem("user", JSON.stringify(result.user));
      window.dispatchEvent(new Event("storage"));

      setTimeout(() => {
        navigate("/profile");
      }, 1500);
    } else {
      toast.error(result.message || "Google login failed.");
    }
  } catch (error) {
    console.error("Google Login Error:", error);
    toast.error("Google login error.");
  }
};


  // Custom Google login button using hook
  const loginWithGoogle = useGoogleLogin({
    onSuccess: handleGoogleLogin,
    onError: () => toast.error("Google login failed."),
  });

  const [rememberMe, setRememberMe] = useState(false);



  return (
    <div className="bg-[#1e1a2e] flex flex-row justify-center w-full min-h-screen">
      <div className="bg-[#1e1a2e] w-full min-h-screen relative flex flex-col md:flex-row">
     <div className="relative md:w-1/2 h-[400px] md:h-auto bg-[url('https://c.animaapp.com/md5xyn9tuhXTFK/img/2151800485.png')] bg-cover bg-center">
  {/* Optional Gradient Overlay */}
  <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[#1e1a2e] z-0" />

  {/* Text Overlay */}
  <div className="absolute bottom-10 left-6 md:bottom-20 md:left-10 z-10">
    <h2 className="text-xl md:text-3xl font-bold text-white mb-12">
      Welcome back our
    </h2>
    <h1
      className="text-2xl md:text-4xl font-extrabold bg-clip-text text-transparent mb-12"
      style={{
        backgroundImage:
          "linear-gradient(90deg, rgba(255,110,179,1) 0%, rgba(170,129,255,1) 47%, rgba(107,201,255,1) 100%)",
      }}
    >
      Baby Unicorn AI
    </h1>
  </div>
</div>

        <div className="md:w-1/2 flex items-center justify-center p-4 md:p-16">
          <div className="flex flex-col w-full max-w-[634px] items-center gap-8 p-6 md:p-16 bg-[#2a223a] w-full max-w-lg p-10 rounded-3xl bg-[#2a223a] relative overflow-hidden before:content-[''] before:absolute before:inset-0 before:p-1.5 before:rounded-3xl before:[background:linear-gradient(90deg,rgba(45,40,66,1)_2%,rgba(255,110,179,1)_16%,rgba(170,129,255,1)_47%,rgba(107,201,255,1)_83%,rgba(50,43,70,1)_97%)] before:[-webkit-mask:linear-gradient(#fff_0_0)_content-box,linear-gradient(#fff_0_0)] before:[-webkit-mask-composite:xor] before:[mask-composite:exclude] before:z-[1] before:pointer-events-none">
            <div className="flex flex-col items-center gap-2">
              <img
                src="https://c.animaapp.com/md5xyn9tuhXTFK/img/freepik--the-style-is-candid-image-photography-with-natural--633.png"
                alt="Logo"
                className="w-12 h-12"
              />
              <div className="text-transparent bg-clip-text bg-gradient-to-r from-pink-400 via-purple-400 to-blue-400 text-2xl font-bold">
                BABY UNICORN
              </div>
              <h2 className="text-white text-2xl font-bold">Sign In</h2>
              <p className="text-[#bebebe] text-base text-center">Get access to your account</p>
            </div>

            <div className="flex flex-col gap-4 w-full">
              {/* Email Field */}
              <div className="flex items-center gap-2 p-3.5 w-full bg-[#3a335066] rounded-md backdrop-blur-md h-[60px] items-center justify-between relative before:content-[''] before:absolute before:inset-0 before:p-px before:rounded-md before:[background:linear-gradient(356deg,rgba(45,40,66,0)_2%,rgba(255,110,179,1)_16%,rgba(170,129,255,1)_47%,rgba(107,201,255,1)_83%,rgba(50,43,70,0)_97%)] before:[-webkit-mask:linear-gradient(#fff_0_0)_content-box,linear-gradient(#fff_0_0)] before:[-webkit-mask-composite:xor] before:[mask-composite:exclude] before:z-[1] before:pointer-events-none">
                <VuesaxBulkSms className="w-5 h-5" />
                <input
                  type="email"
                  placeholder="Email"
                  value={formData.email}
                  onChange={(e) => handleChange("email", e.target.value)}
                  className="bg-transparent text-[#bebebe] placeholder-[#bebebe] outline-none w-full"
                />
              </div>

              {/* Password Field */}
              <div className="flex items-center gap-2 p-3.5 w-full bg-[#3a335066] rounded-md backdrop-blur-md h-[60px] items-center justify-between relative before:content-[''] before:absolute before:inset-0 before:p-px before:rounded-md before:[background:linear-gradient(356deg,rgba(45,40,66,0)_2%,rgba(255,110,179,1)_16%,rgba(170,129,255,1)_47%,rgba(107,201,255,1)_83%,rgba(50,43,70,0)_97%)] before:[-webkit-mask:linear-gradient(#fff_0_0)_content-box,linear-gradient(#fff_0_0)] before:[-webkit-mask-composite:xor] before:[mask-composite:exclude] before:z-[1] before:pointer-events-none">
                <VuesaxBulkKey className="w-5 h-5" />
                <input
                    type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  value={formData.password}
                  onChange={(e) => handleChange("password", e.target.value)}
                  className="bg-transparent text-[#bebebe] placeholder-[#bebebe] outline-none w-full"
                />
                   <span onClick={() => setShowPassword((v) => !v)} className="cursor-pointer ml-2 flex items-center">
                                         {showPassword ? <FiEye size={22} /> : <FiEyeOff size={22} />}
                                       </span>
              </div>

              {/* Remember + Forgot Link */}
              <div className="flex justify-between items-center w-full text-[#bebebe] text-sm">
                <label className="flex items-center gap-2">
                  <input type="checkbox" className="accent-pink-500" />
                  Remember me
                </label>
                <Link to="/reset-password" className="text-[#93b5ff] hover:underline">
                  Forgot Password?
                </Link>
              </div>

              {/* Submit */}
              <button
                onClick={handleLogin}
                className="bg-gradient-to-r from-pink-400 via-purple-400 to-blue-400 text-white font-semibold px-8 py-3 rounded-full w-full shadow-lg"
              >
                Login
              </button>

              {/* Divider */}
              <div className="text-center text-[#bebebe]">or</div>

              {/* Custom Google Login Button */}
              <div className="flex flex-col items-start gap-6 relative self-stretch w-full flex-[0_0_auto]">
                <div
                  onClick={loginWithGoogle}
                  className="cursor-pointer flex h-[60px] items-center justify-center gap-2 px-3 py-3.5 relative self-stretch w-full 
                  rounded-[50px] border-none transition hover:opacity-90 active:scale-[.98]
                  before:content-[''] before:absolute before:inset-0 before:p-px before:rounded-[50px]
                  before:[background:linear-gradient(90deg,rgba(255,110,179,1)_0%,rgba(170,129,255,1)_50%,rgba(107,201,255,1)_100%)]
                  before:[-webkit-mask:linear-gradient(#fff_0_0)_content-box,linear-gradient(#fff_0_0)]
                  before:[-webkit-mask-composite:xor] before:[mask-composite:exclude] before:z-[1] before:pointer-events-none"
                >
                  {/* Optional: Google SVG icon */}
                  {/* <img src="https://www.svgrepo.com/show/475656/google-color.svg" alt="Google" className="h-5 w-5" /> */}
                  <span className="relative text-white text-lg font-medium">
                    Sign in with Google
                  </span>
                </div>
              </div>
              {/* END Google Login */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginPages;
